import { render, staticRenderFns } from "./ApplyChangeName.vue?vue&type=template&id=aa7ae826&scoped=true"
import script from "./ApplyChangeName.vue?vue&type=script&lang=js"
export * from "./ApplyChangeName.vue?vue&type=script&lang=js"
import style0 from "./ApplyChangeName.vue?vue&type=style&index=0&id=aa7ae826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7ae826",
  null
  
)

export default component.exports